import { Badge, Box, Flex, Heading, Separator, Text } from "@radix-ui/themes";
import i18next from "i18next";
import React, { memo, FC } from "react";
import { SingleChallengeFormulaProps } from "./SingleChallengeFormula.types";
import { PlusIcon } from "@radix-ui/react-icons";
import SingleChallengeFormulaFallGuys from "./SingleChallengeFormula.FallGuys";
import { criteriaMapping } from "../../utils/criteriaMapping";

const SingleChallengeFormula: FC<SingleChallengeFormulaProps> = (
  props
): JSX.Element => {
  // Check if there are multiple criteria
  const hasMultipleCriteria =
    props.coefficients && Object.keys(props.coefficients).length > 1;

  // Check if there is a min criteria. F.e. lowest score wins
  const hasMinCriteria =
    props.coefficients && Object.values(props.coefficients)[0] === -1;

  const isRacing = props.isRacing;

  // Fall Guys
  const isFallGuys = props.game === "fallguys";
  const fieldToComPareFinalPoints =
    props.fieldToCompare.includes("finalPoints");

  return (
    <Box my="2">
      <Box py="4">
        <Separator decorative style={{ width: "100%" }} />
      </Box>
      <Heading as="h2" size="3" mb="1">
        {i18next.t("challengeCriteria.headline")}
      </Heading>
      {isFallGuys && fieldToComPareFinalPoints ? (
        <SingleChallengeFormulaFallGuys />
      ) : (
        <Flex gap="1" wrap="wrap">
          {props.coefficients ? (
            Object.entries(props.coefficients).map(
              ([key, value], index, array) => (
                <Flex gap="1" align="center" key={`${key}_${index}`}>
                  <Badge>
                    <Flex gap="1" align="center">
                      <Text>
                        {isRacing
                          ? !hasMultipleCriteria &&
                            hasMinCriteria &&
                            i18next.t("challengeCriteria.type.fastest")
                          : !hasMultipleCriteria &&
                            hasMinCriteria &&
                            i18next.t("challengeCriteria.type.least")}

                        {isRacing
                          ? !hasMultipleCriteria &&
                            !hasMinCriteria &&
                            i18next.t("challengeCriteria.type.slowest")
                          : !hasMultipleCriteria &&
                            !hasMinCriteria &&
                            i18next.t("challengeCriteria.type.most")}
                      </Text>

                      {/* Criteria */}
                      <Text>{i18next.t(criteriaMapping[key]) || key}</Text>

                      {/* Text to show if advanced challenge*/}
                      {hasMultipleCriteria && <Text>* {Math.abs(value)}</Text>}
                    </Flex>
                  </Badge>
                  {/* Plus icon */}
                  {hasMultipleCriteria && index < array.length - 1 && (
                    <PlusIcon />
                  )}
                </Flex>
              )
            )
          ) : (
            <Text size="2" color="gray">
              The coefficients were not specified.
            </Text>
          )}
        </Flex>
      )}
      <Box py="4">
        <Separator decorative style={{ width: "100%" }} />
      </Box>
    </Box>
  );
};

export default memo(SingleChallengeFormula);
